import { z } from 'zod'

const optionalText = (max: number) =>
  z.string().max(max).optional().or(z.literal(''))

export const storeAssetFormSchema = z.object({
  brand_name: z.string().min(1, 'Brand is required'),
  category_name: z.string().min(1, 'Machine type is required'),
  model: z.string().min(1, 'Model is required').max(255),
  serial_number: z.string().min(1, 'Serial number is required').max(255),
  function: z.string().min(1, 'Function is required').max(255),
  tag_number: optionalText(100),
  manufacturer: optionalText(255),
  sw_provider: optionalText(255),
  warranty_date: optionalText(10),
  order_received_date: optionalText(10),
  ram: optionalText(255),
  disk_space: optionalText(255),
  os_version: optionalText(255),
  ms_office: optionalText(255),
  processor: optionalText(255),
  cpu: optionalText(255),
  ip_address: optionalText(45),
  mac_address: optionalText(45),
})

export type StoreAssetFormData = z.infer<typeof storeAssetFormSchema>

export const emptyStoreAssetForm = (): StoreAssetFormData => ({
  brand_name: '',
  category_name: '',
  model: '',
  tag_number: '',
  serial_number: '',
  function: '',
  manufacturer: '',
  sw_provider: '',
  warranty_date: '',
  order_received_date: '',
  ram: '',
  disk_space: '',
  os_version: '',
  ms_office: '',
  processor: '',
  cpu: '',
  ip_address: '',
  mac_address: '',
})
